/* eslint-disable no-empty */

export function initForm() {
    const f = document.querySelector(".form-iscrizione");
    if (!f) return;
    const countrySelector = f.querySelector("#Nazione");
    /*if (countrySelector && !countrySelector.value.length) return true;*/
    if (!countrySelector || !countrySelector.value) return;
    if (countrySelector.value == "IT") {
        $(".foreign-location", f).hide();
        $(".italy-location:hidden", f).show();
    } else {
        $(".italy-location", f).hide();
        $(".foreign-location:hidden", f).show();
    }
}
  